import { render } from "./Logout.vue?vue&type=template&id=0a06696a&scoped=true&bindings={}"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"

import "./Logout.vue?vue&type=style&index=0&id=0a06696a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a06696a"

export default script